import styled from 'styled-components';

export const StyledGuardianCell = styled.div`
   display: flex;
   flex-direction: column;
   gap: 5px;
`;
StyledGuardianCell.displayName = 'StyledGuardianCell';
